/**
 * @fileoverview gRPC-Web generated client stub for admpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.admpb = require('./tablesettings_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.admpb.TableSettingsServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.admpb.TableSettingsServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.TableSettings,
 *   !proto.admpb.CreateTableSettingsResponse>}
 */
const methodDescriptor_TableSettingsService_CreateTableSettings = new grpc.web.MethodDescriptor(
  '/admpb.TableSettingsService/CreateTableSettings',
  grpc.web.MethodType.UNARY,
  proto.admpb.TableSettings,
  proto.admpb.CreateTableSettingsResponse,
  /**
   * @param {!proto.admpb.TableSettings} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.CreateTableSettingsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.admpb.TableSettings,
 *   !proto.admpb.CreateTableSettingsResponse>}
 */
const methodInfo_TableSettingsService_CreateTableSettings = new grpc.web.AbstractClientBase.MethodInfo(
  proto.admpb.CreateTableSettingsResponse,
  /**
   * @param {!proto.admpb.TableSettings} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.CreateTableSettingsResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.TableSettings} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.admpb.CreateTableSettingsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.CreateTableSettingsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.TableSettingsServiceClient.prototype.createTableSettings =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.TableSettingsService/CreateTableSettings',
      request,
      metadata || {},
      methodDescriptor_TableSettingsService_CreateTableSettings,
      callback);
};


/**
 * @param {!proto.admpb.TableSettings} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.CreateTableSettingsResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.TableSettingsServicePromiseClient.prototype.createTableSettings =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.TableSettingsService/CreateTableSettings',
      request,
      metadata || {},
      methodDescriptor_TableSettingsService_CreateTableSettings);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.TableSettings,
 *   !proto.admpb.UpdateTableSettingsResponse>}
 */
const methodDescriptor_TableSettingsService_UpdateTableSettings = new grpc.web.MethodDescriptor(
  '/admpb.TableSettingsService/UpdateTableSettings',
  grpc.web.MethodType.UNARY,
  proto.admpb.TableSettings,
  proto.admpb.UpdateTableSettingsResponse,
  /**
   * @param {!proto.admpb.TableSettings} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.UpdateTableSettingsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.admpb.TableSettings,
 *   !proto.admpb.UpdateTableSettingsResponse>}
 */
const methodInfo_TableSettingsService_UpdateTableSettings = new grpc.web.AbstractClientBase.MethodInfo(
  proto.admpb.UpdateTableSettingsResponse,
  /**
   * @param {!proto.admpb.TableSettings} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.UpdateTableSettingsResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.TableSettings} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.admpb.UpdateTableSettingsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.UpdateTableSettingsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.TableSettingsServiceClient.prototype.updateTableSettings =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.TableSettingsService/UpdateTableSettings',
      request,
      metadata || {},
      methodDescriptor_TableSettingsService_UpdateTableSettings,
      callback);
};


/**
 * @param {!proto.admpb.TableSettings} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.UpdateTableSettingsResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.TableSettingsServicePromiseClient.prototype.updateTableSettings =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.TableSettingsService/UpdateTableSettings',
      request,
      metadata || {},
      methodDescriptor_TableSettingsService_UpdateTableSettings);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.TableSettings,
 *   !proto.admpb.ReadTableSettingsResponse>}
 */
const methodDescriptor_TableSettingsService_ReadTableSettings = new grpc.web.MethodDescriptor(
  '/admpb.TableSettingsService/ReadTableSettings',
  grpc.web.MethodType.UNARY,
  proto.admpb.TableSettings,
  proto.admpb.ReadTableSettingsResponse,
  /**
   * @param {!proto.admpb.TableSettings} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ReadTableSettingsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.admpb.TableSettings,
 *   !proto.admpb.ReadTableSettingsResponse>}
 */
const methodInfo_TableSettingsService_ReadTableSettings = new grpc.web.AbstractClientBase.MethodInfo(
  proto.admpb.ReadTableSettingsResponse,
  /**
   * @param {!proto.admpb.TableSettings} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ReadTableSettingsResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.TableSettings} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.admpb.ReadTableSettingsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.ReadTableSettingsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.TableSettingsServiceClient.prototype.readTableSettings =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.TableSettingsService/ReadTableSettings',
      request,
      metadata || {},
      methodDescriptor_TableSettingsService_ReadTableSettings,
      callback);
};


/**
 * @param {!proto.admpb.TableSettings} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.ReadTableSettingsResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.TableSettingsServicePromiseClient.prototype.readTableSettings =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.TableSettingsService/ReadTableSettings',
      request,
      metadata || {},
      methodDescriptor_TableSettingsService_ReadTableSettings);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.TableSettings,
 *   !proto.admpb.EmptyTableSettingsResponse>}
 */
const methodDescriptor_TableSettingsService_DeleteTableSettings = new grpc.web.MethodDescriptor(
  '/admpb.TableSettingsService/DeleteTableSettings',
  grpc.web.MethodType.UNARY,
  proto.admpb.TableSettings,
  proto.admpb.EmptyTableSettingsResponse,
  /**
   * @param {!proto.admpb.TableSettings} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.EmptyTableSettingsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.admpb.TableSettings,
 *   !proto.admpb.EmptyTableSettingsResponse>}
 */
const methodInfo_TableSettingsService_DeleteTableSettings = new grpc.web.AbstractClientBase.MethodInfo(
  proto.admpb.EmptyTableSettingsResponse,
  /**
   * @param {!proto.admpb.TableSettings} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.EmptyTableSettingsResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.TableSettings} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.admpb.EmptyTableSettingsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.EmptyTableSettingsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.TableSettingsServiceClient.prototype.deleteTableSettings =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.TableSettingsService/DeleteTableSettings',
      request,
      metadata || {},
      methodDescriptor_TableSettingsService_DeleteTableSettings,
      callback);
};


/**
 * @param {!proto.admpb.TableSettings} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.EmptyTableSettingsResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.TableSettingsServicePromiseClient.prototype.deleteTableSettings =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.TableSettingsService/DeleteTableSettings',
      request,
      metadata || {},
      methodDescriptor_TableSettingsService_DeleteTableSettings);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.RoleTableSettings,
 *   !proto.admpb.CreateRoleTableSettingsResponse>}
 */
const methodDescriptor_TableSettingsService_CreateRoleTableSettings = new grpc.web.MethodDescriptor(
  '/admpb.TableSettingsService/CreateRoleTableSettings',
  grpc.web.MethodType.UNARY,
  proto.admpb.RoleTableSettings,
  proto.admpb.CreateRoleTableSettingsResponse,
  /**
   * @param {!proto.admpb.RoleTableSettings} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.CreateRoleTableSettingsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.admpb.RoleTableSettings,
 *   !proto.admpb.CreateRoleTableSettingsResponse>}
 */
const methodInfo_TableSettingsService_CreateRoleTableSettings = new grpc.web.AbstractClientBase.MethodInfo(
  proto.admpb.CreateRoleTableSettingsResponse,
  /**
   * @param {!proto.admpb.RoleTableSettings} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.CreateRoleTableSettingsResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.RoleTableSettings} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.admpb.CreateRoleTableSettingsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.CreateRoleTableSettingsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.TableSettingsServiceClient.prototype.createRoleTableSettings =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.TableSettingsService/CreateRoleTableSettings',
      request,
      metadata || {},
      methodDescriptor_TableSettingsService_CreateRoleTableSettings,
      callback);
};


/**
 * @param {!proto.admpb.RoleTableSettings} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.CreateRoleTableSettingsResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.TableSettingsServicePromiseClient.prototype.createRoleTableSettings =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.TableSettingsService/CreateRoleTableSettings',
      request,
      metadata || {},
      methodDescriptor_TableSettingsService_CreateRoleTableSettings);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.RoleTableSettings,
 *   !proto.admpb.UpdateRoleTableSettingsResponse>}
 */
const methodDescriptor_TableSettingsService_UpdateRoleTableSettings = new grpc.web.MethodDescriptor(
  '/admpb.TableSettingsService/UpdateRoleTableSettings',
  grpc.web.MethodType.UNARY,
  proto.admpb.RoleTableSettings,
  proto.admpb.UpdateRoleTableSettingsResponse,
  /**
   * @param {!proto.admpb.RoleTableSettings} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.UpdateRoleTableSettingsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.admpb.RoleTableSettings,
 *   !proto.admpb.UpdateRoleTableSettingsResponse>}
 */
const methodInfo_TableSettingsService_UpdateRoleTableSettings = new grpc.web.AbstractClientBase.MethodInfo(
  proto.admpb.UpdateRoleTableSettingsResponse,
  /**
   * @param {!proto.admpb.RoleTableSettings} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.UpdateRoleTableSettingsResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.RoleTableSettings} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.admpb.UpdateRoleTableSettingsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.UpdateRoleTableSettingsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.TableSettingsServiceClient.prototype.updateRoleTableSettings =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.TableSettingsService/UpdateRoleTableSettings',
      request,
      metadata || {},
      methodDescriptor_TableSettingsService_UpdateRoleTableSettings,
      callback);
};


/**
 * @param {!proto.admpb.RoleTableSettings} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.UpdateRoleTableSettingsResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.TableSettingsServicePromiseClient.prototype.updateRoleTableSettings =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.TableSettingsService/UpdateRoleTableSettings',
      request,
      metadata || {},
      methodDescriptor_TableSettingsService_UpdateRoleTableSettings);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.RoleTableSettings,
 *   !proto.admpb.ReadRoleTableSettingsResponse>}
 */
const methodDescriptor_TableSettingsService_ReadRoleTableSettings = new grpc.web.MethodDescriptor(
  '/admpb.TableSettingsService/ReadRoleTableSettings',
  grpc.web.MethodType.UNARY,
  proto.admpb.RoleTableSettings,
  proto.admpb.ReadRoleTableSettingsResponse,
  /**
   * @param {!proto.admpb.RoleTableSettings} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ReadRoleTableSettingsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.admpb.RoleTableSettings,
 *   !proto.admpb.ReadRoleTableSettingsResponse>}
 */
const methodInfo_TableSettingsService_ReadRoleTableSettings = new grpc.web.AbstractClientBase.MethodInfo(
  proto.admpb.ReadRoleTableSettingsResponse,
  /**
   * @param {!proto.admpb.RoleTableSettings} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ReadRoleTableSettingsResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.RoleTableSettings} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.admpb.ReadRoleTableSettingsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.ReadRoleTableSettingsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.TableSettingsServiceClient.prototype.readRoleTableSettings =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.TableSettingsService/ReadRoleTableSettings',
      request,
      metadata || {},
      methodDescriptor_TableSettingsService_ReadRoleTableSettings,
      callback);
};


/**
 * @param {!proto.admpb.RoleTableSettings} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.ReadRoleTableSettingsResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.TableSettingsServicePromiseClient.prototype.readRoleTableSettings =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.TableSettingsService/ReadRoleTableSettings',
      request,
      metadata || {},
      methodDescriptor_TableSettingsService_ReadRoleTableSettings);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.RoleTableSettings,
 *   !proto.admpb.EmptyRoleTableSettingsResponse>}
 */
const methodDescriptor_TableSettingsService_DeleteRoleTableSettings = new grpc.web.MethodDescriptor(
  '/admpb.TableSettingsService/DeleteRoleTableSettings',
  grpc.web.MethodType.UNARY,
  proto.admpb.RoleTableSettings,
  proto.admpb.EmptyRoleTableSettingsResponse,
  /**
   * @param {!proto.admpb.RoleTableSettings} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.EmptyRoleTableSettingsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.admpb.RoleTableSettings,
 *   !proto.admpb.EmptyRoleTableSettingsResponse>}
 */
const methodInfo_TableSettingsService_DeleteRoleTableSettings = new grpc.web.AbstractClientBase.MethodInfo(
  proto.admpb.EmptyRoleTableSettingsResponse,
  /**
   * @param {!proto.admpb.RoleTableSettings} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.EmptyRoleTableSettingsResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.RoleTableSettings} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.admpb.EmptyRoleTableSettingsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.EmptyRoleTableSettingsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.TableSettingsServiceClient.prototype.deleteRoleTableSettings =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.TableSettingsService/DeleteRoleTableSettings',
      request,
      metadata || {},
      methodDescriptor_TableSettingsService_DeleteRoleTableSettings,
      callback);
};


/**
 * @param {!proto.admpb.RoleTableSettings} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.EmptyRoleTableSettingsResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.TableSettingsServicePromiseClient.prototype.deleteRoleTableSettings =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.TableSettingsService/DeleteRoleTableSettings',
      request,
      metadata || {},
      methodDescriptor_TableSettingsService_DeleteRoleTableSettings);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.TableColumns,
 *   !proto.admpb.CreateTableColumnsResponse>}
 */
const methodDescriptor_TableSettingsService_CreateTableColumns = new grpc.web.MethodDescriptor(
  '/admpb.TableSettingsService/CreateTableColumns',
  grpc.web.MethodType.UNARY,
  proto.admpb.TableColumns,
  proto.admpb.CreateTableColumnsResponse,
  /**
   * @param {!proto.admpb.TableColumns} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.CreateTableColumnsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.admpb.TableColumns,
 *   !proto.admpb.CreateTableColumnsResponse>}
 */
const methodInfo_TableSettingsService_CreateTableColumns = new grpc.web.AbstractClientBase.MethodInfo(
  proto.admpb.CreateTableColumnsResponse,
  /**
   * @param {!proto.admpb.TableColumns} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.CreateTableColumnsResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.TableColumns} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.admpb.CreateTableColumnsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.CreateTableColumnsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.TableSettingsServiceClient.prototype.createTableColumns =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.TableSettingsService/CreateTableColumns',
      request,
      metadata || {},
      methodDescriptor_TableSettingsService_CreateTableColumns,
      callback);
};


/**
 * @param {!proto.admpb.TableColumns} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.CreateTableColumnsResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.TableSettingsServicePromiseClient.prototype.createTableColumns =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.TableSettingsService/CreateTableColumns',
      request,
      metadata || {},
      methodDescriptor_TableSettingsService_CreateTableColumns);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.TableColumns,
 *   !proto.admpb.UpdateTableColumnsResponse>}
 */
const methodDescriptor_TableSettingsService_UpdateTableColumns = new grpc.web.MethodDescriptor(
  '/admpb.TableSettingsService/UpdateTableColumns',
  grpc.web.MethodType.UNARY,
  proto.admpb.TableColumns,
  proto.admpb.UpdateTableColumnsResponse,
  /**
   * @param {!proto.admpb.TableColumns} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.UpdateTableColumnsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.admpb.TableColumns,
 *   !proto.admpb.UpdateTableColumnsResponse>}
 */
const methodInfo_TableSettingsService_UpdateTableColumns = new grpc.web.AbstractClientBase.MethodInfo(
  proto.admpb.UpdateTableColumnsResponse,
  /**
   * @param {!proto.admpb.TableColumns} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.UpdateTableColumnsResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.TableColumns} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.admpb.UpdateTableColumnsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.UpdateTableColumnsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.TableSettingsServiceClient.prototype.updateTableColumns =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.TableSettingsService/UpdateTableColumns',
      request,
      metadata || {},
      methodDescriptor_TableSettingsService_UpdateTableColumns,
      callback);
};


/**
 * @param {!proto.admpb.TableColumns} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.UpdateTableColumnsResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.TableSettingsServicePromiseClient.prototype.updateTableColumns =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.TableSettingsService/UpdateTableColumns',
      request,
      metadata || {},
      methodDescriptor_TableSettingsService_UpdateTableColumns);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.TableColumns,
 *   !proto.admpb.ReadTableColumnsResponse>}
 */
const methodDescriptor_TableSettingsService_ReadTableColumns = new grpc.web.MethodDescriptor(
  '/admpb.TableSettingsService/ReadTableColumns',
  grpc.web.MethodType.UNARY,
  proto.admpb.TableColumns,
  proto.admpb.ReadTableColumnsResponse,
  /**
   * @param {!proto.admpb.TableColumns} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ReadTableColumnsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.admpb.TableColumns,
 *   !proto.admpb.ReadTableColumnsResponse>}
 */
const methodInfo_TableSettingsService_ReadTableColumns = new grpc.web.AbstractClientBase.MethodInfo(
  proto.admpb.ReadTableColumnsResponse,
  /**
   * @param {!proto.admpb.TableColumns} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ReadTableColumnsResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.TableColumns} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.admpb.ReadTableColumnsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.ReadTableColumnsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.TableSettingsServiceClient.prototype.readTableColumns =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.TableSettingsService/ReadTableColumns',
      request,
      metadata || {},
      methodDescriptor_TableSettingsService_ReadTableColumns,
      callback);
};


/**
 * @param {!proto.admpb.TableColumns} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.ReadTableColumnsResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.TableSettingsServicePromiseClient.prototype.readTableColumns =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.TableSettingsService/ReadTableColumns',
      request,
      metadata || {},
      methodDescriptor_TableSettingsService_ReadTableColumns);
};


module.exports = proto.admpb;

